var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFrame = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24 0H0v24h24z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00844D",
  d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFrame);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/frame.aa2e46ec2298e0ab4f521471e325832f.svg";